import React, { useEffect, useState } from "react";
import { corefetch } from "../../../Util/axios_core_helper";

const ContactSection = () => {
  const [ContactList, setContactList] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const list = await corefetch("ContactUs/GetContactList");
        if (list && list.length > 0) {
          setContactList(list);
        } else {
          setContactList([]);
        }
      } catch (error) {
        setContactList([]);
        console.error("Error fetching list:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <section className="wpo-contact-pg-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col col-lg-10 offset-lg-1">
              <div className="office-info" style={{ paddingBottom: "0px" }}>
                <div className="row">
                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-maps-and-flags"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Address</h2>
                        {ContactList != null &&
                          ContactList.length > 0 &&
                          ContactList?.map(
                            (contact, index) =>
                              contact.contactType == "Address" && (
                                <p key={index}>{contact.details}</p>
                              )
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-email"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Email Us</h2>
                        {ContactList != null &&
                          ContactList.length > 0 &&
                          ContactList.map(
                            (contact, index) =>
                              contact.contactType == "Email" && (
                                <p className="contactPage" key={index}>
                                  <a href={`mailto:${contact.details}`}>
                                    {contact.details}
                                  </a>
                                </p>
                              )
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-phone-call"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Call Now</h2>
                        {ContactList != null &&
                          ContactList.length > 0 &&
                          ContactList.map(
                            (contact, index) =>
                              contact.contactType == "PhoneNumber" && (
                                <p className="contactPage" key={index}>
                                  <a href={`tel:${contact.details}`}>
                                    {contact.details}
                                  </a>
                                </p>
                              )
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactSection;
